import { useState } from "react";
import Chart from "react-apexcharts";

const BarChart = ({ categories, data, name, xaxisTitle, background }: any) => {
  const [chartOptions, setChartOptions] = useState({
    options: {
      chart: {
        toolbar: {
          show: false,
        },
        id: name,
        fontFamily: "iran-sans",
      },
      grid: {
        show: false,
      },
      legend: {
        show: true,
      },
      colors: [background],
      plotOptions: {
        bar: {
          borderRadius: 2,
          columnWidth: "85%",
          dataLabels: {
            position: "center",
          },
        },
      },
      xaxis: {
        title: {
          text: xaxisTitle ?? "",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "16px",
            fontFamily: "rokh",
            fontWeight: 900,
          },
        },
        categories: categories.map((cat: string | number) =>
          cat === null ? "وارد نشده" : cat
        ),
      },
      yaxis: {
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: true,
        },
      },
      tooltip: {
        style: {
          fontSize: "12px",
          fontFamily: "iran-sans",
        },
        theme: "light",
        //@ts-ignore
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          return `<div style="direction: rtl; text-align: right; padding: 5px; font-size: 12px;">
                    ${name}: ${series[seriesIndex][dataPointIndex]}
                  </div>`;
        },
      },
    },
    series: [
      {
        name: name,
        data: data,
      },
    ],
  });

  return (
    <div className="bar-chart w-full">
      <Chart
        //@ts-ignore
        options={chartOptions.options}
        series={chartOptions.series}
        type="bar"
        width="100%"
        height={300}
      />
    </div>
  );
};

export default BarChart;
